import { render, staticRenderFns } from "./DocTipo.vue?vue&type=template&id=65afde95&scoped=true&"
import script from "./DocTipo.vue?vue&type=script&lang=js&"
export * from "./DocTipo.vue?vue&type=script&lang=js&"
import style0 from "./DocTipo.vue?vue&type=style&index=0&id=65afde95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afde95",
  null
  
)

export default component.exports